const auth_status = {
    page_title: 'Status de autenticação',
    title: 'Status de autenticação',
    description: 'Verifique o status da autenticação.',
};
export default Object.freeze(auth_status);
